import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Logo } from "./Logo";
import { LangSwitch } from "./Header";

export const CONTACT = { phone: "06 75 56 39 78", phoneHref: "tel:+33675563978", email: "team@sidly.space", address: "8 Rue Huguette Heitzmann, 93170 Bagnolet" };

export function Footer() {
  const { t, to } = useLang();
  const openCookies = () => window.dispatchEvent(new Event("sidly:cookies"));
  return (
    <footer className="relative overflow-hidden bg-navy text-slate-300" data-testid="site-footer">
      <div className="grain absolute inset-0" />
      <div className="container-x relative grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-12 lg:py-20">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
          <div className="mt-8">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{t.footer.language}</p>
            <LangSwitch id="footer" dark />
          </div>
        </div>
        <div className="lg:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{t.footer.nav}</p>
          <ul className="mt-5 space-y-3 text-sm">
            {["home", "services", "about", "contact"].map((k) => (
              <li key={k}><Link to={to(k)} className="transition-colors hover:text-white" data-testid={`footer-${k}-link`}>{t.nav[k]}</Link></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{t.footer.legal}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to={to("legal")} className="transition-colors hover:text-white" data-testid="footer-legal-mentions-link">{t.footer.legalNotice}</Link></li>
            <li><Link to={to("terms")} className="transition-colors hover:text-white" data-testid="footer-cgu-cgv-link">{t.footer.terms}</Link></li>
            <li><Link to={to("privacy")} className="transition-colors hover:text-white" data-testid="footer-privacy-link">{t.footer.privacy}</Link></li>
            <li><button type="button" onClick={openCookies} className="transition-colors hover:text-white" data-testid="footer-cookies-button">{t.footer.cookies}</button></li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{t.footer.contact}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-2.5 transition-colors hover:text-white" data-testid="footer-phone-link"><Phone size={15} className="text-teal-400" />{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 transition-colors hover:text-white" data-testid="footer-email-link"><Mail size={15} className="text-teal-400" />{CONTACT.email}</a></li>
            <li className="flex items-start gap-2.5"><MapPin size={15} className="mt-0.5 shrink-0 text-teal-400" /><span data-testid="footer-address">{CONTACT.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-company">{t.footer.company}</p>
          <p>© {new Date().getFullYear()} SIDLY. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
